import { Bell, Link2, ScanSearch } from "lucide-react";

const steps = [
  {
    icon: Link2,
    number: "01",
    title: "Connect your accounts",
    description: "Securely link your financial accounts in seconds",
  },
  {
    icon: ScanSearch,
    number: "02",
    title: "Cura identifies your bills, subscriptions, and renewals",
    description: "Our intelligent system automatically categorizes everything",
  },
  {
    icon: Bell,
    number: "03",
    title: "Get a unified view and intelligent alerts",
    description: "Stay in control with timely notifications and clear insights",
  },
];

const HowItWorks = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title}>How Cura Works</h2>
        </div>

        <div style={styles.grid}>
          {steps.map((step, index) => (
            <StepCard key={index} step={step} />
          ))}
        </div>
      </div>
    </section>
  );
};

const StepCard = ({ step }: { step: (typeof steps)[0] }) => {
  const Icon = step.icon;

  return (
    <div style={styles.card}>
      <div style={styles.iconContainer}>
        <div style={styles.iconBox}>
          <Icon style={styles.icon} />
        </div>
        <div style={styles.badge}>{step.number}</div>
      </div>

      <h3 style={styles.cardTitle}>{step.title}</h3>
      <p style={styles.cardDescription}>{step.description}</p>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    padding: "2rem 1rem",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 0.75rem",
  },
  header: {
    textAlign: "center",
    marginBottom: "2rem",
  },
  title: {
    fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
    fontWeight: "600",
    color: "#000",
    lineHeight: "1.2",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
    gap: "1.5rem",
    maxWidth: "80rem",
    margin: "0 auto",
  },
  card: {
    position: "relative",
    textAlign: "center",
    padding: "0 0.5rem",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "1.25rem",
    position: "relative",
  },
  iconBox: {
    padding: "1.25rem",
    backgroundColor: "#fff",
    borderRadius: "1rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    border: "1px solid rgba(0,0,0,0.1)",
  },
  icon: {
    height: "2rem",
    width: "2rem",
    color: "#6366f1",
  },
  badge: {
    position: "absolute",
    top: "-0.5rem",
    right: "calc(50% - 3rem)",
    backgroundColor: "#6366f1",
    color: "#fff",
    borderRadius: "9999px",
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    fontWeight: "600",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  },
  cardTitle: {
    fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
    fontWeight: "600",
    marginBottom: "0.5rem",
    color: "#000",
    lineHeight: "1.3",
  },
  cardDescription: {
    fontSize: "clamp(0.875rem, 2vw, 1rem)",
    color: "#6b7280",
    lineHeight: "1.6",
  },
};

export default HowItWorks;
